// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"143":"3dc2af8e","322":"e0a17b14","443":"b82ad350","894":"893699ae"}[chunkId] + ".chunk.css";
};